import * as types from '../../index';


export const clientCategoryListAction = (data) => {
    return {
    type: types.CLIENT_CATEGORY_LIST,
    data
    }
};


export const clientCategoryAddAction = (data) => {
    return {
    type: types.CLIENT_CATEGORY_ADD,
    data
    }
};

export const clientCategoryEditAction = (data) => {
    return {
    type: types.CLIENT_CATEGORY_EDIT,
    data
    }
};

export const clientCategoryUpdateAction = (data) => {
    return {
    type: types.CLIENT_CATEGORY_UPDATE,
    data
    }
};

export const clientCategoryDeleteAction = (data) => {
    return {
    type: types.CLIENT_CATEGORY_DELETE,
    data
    }
};